import React, { Fragment, useContext, useEffect } from 'react';
import Head from 'next/head';

// import appConfig from '../appConfig';

import { ALLOW_PRODUCT_COMPARE } from '../constants/verificationConst';
import CompareProducts from './Compare/CompareProducts';
import Page404 from '../pages/404';
import Header from './Header';
import useSegment from '../hooks/segment';
import { useConfigData } from '../Context/ConfigProvider';

export default function ComparePage() {
  const { trackEvent } = useSegment()
  const appConfig = useConfigData();
  if (!ALLOW_PRODUCT_COMPARE) {
    return <Page404 />;
  }

  useEffect(() => {
    trackEvent("Compare page opened")
  }, [])

  if (process.browser) {
    return (
      <Fragment>
        <Head>
          <title>{`Compare Products | ${appConfig.META_TITLE_DESCRIPTION}`}</title>
        </Head>

        <Header minimalNavbar hasText backPath toPath="/" pageName="Compare Products" hasWhiteBg search={false} />

        <div className="compare-page-content container">
          <CompareProducts fullPage />
        </div>
      </Fragment>
    );
  }

  return null;
}
